import React, { useCallback } from 'react';

import { useParams } from 'react-router-dom';

import useAppNavigation from '~/hooks/useAppNavigation';

import InclusionsFilterBulkModal from './InclusionsFilterBulkModal';

type Props = {
  vendorId: string;
  onSave: () => void;
};

function InclusionsFilterCreate({ vendorId, onSave }: Props) {
  const { inclusionId } = useParams<{ inclusionId: string }>();
  const { push } = useAppNavigation();

  const handleClose = useCallback(() => {
    push(`/cruises/inclusions/edit/${inclusionId}/filters`);
  }, [push, inclusionId]);

  return (
    <InclusionsFilterBulkModal
      open
      inclusionId={inclusionId}
      vendorId={vendorId}
      onSave={onSave}
      onClose={handleClose}
    />
  );
}

export default InclusionsFilterCreate;
